var _rect, _rect2, _line, _line2, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    fill: "#a8a8a8",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 184,
    height: 184,
    rx: 8,
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 112,
    x2: 120,
    y2: 176,
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 112,
    x2: 88,
    y2: 176,
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120,140a28,28,0,0,1,56,0v36",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 80,
    r: 12
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.ad8a0822b3135a1fda68a56d45d3cd14.svg";
export { ForwardRef as ReactComponent };